import React, { ReactNode } from "react";
import cn from "classnames";

type BtnProps = {
  children: ReactNode;
  color?: "orange" | "white";
  onClick?: () => void;
};

export const ModalBtn = ({ children, color = "orange", onClick }: BtnProps) => (
  <div
    className={cn(
      "inline-flex justify-center",
      "rounded-md  px-4 py-2",
      {
        "bg-accuRankerOrange-500 text-white hover:bg-accuRankerOrange-900 focus:ring-accuRankerOrange-900":
          color === "orange",
        "bg-white text-gray-700 outline outline-1 outline-offset-[-1px] outline-gray-300 hover:bg-gray-50":
          color === "white", // mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
      },
      "transition-colors duration-300",
      "shadow-sm", // does this even do anything?
      "focus:ring-2 focus:ring-offset-2", // does this even do anything?
      "focus:outline-none",
      "font-medium",
      "sm:mt-0 sm:text-sm",
      "md:text-base",
      "cursor-pointer"
    )}
    onClick={onClick}
  >
    {children}
  </div>
);
